export default "__VITE_ASSET__64ae0480__"